import { fetchBotSubscriptions } from "./user";
import AudioElement from "../../utils/AudioElement";
import { UserServiceClientApi } from '../../services/api/UserApiServices';
import { setLoader, setSearchLoader } from "./loader";

export const BOTS_RECEIVED = "BOTS_RECEIVED";
export const COMPANIES_RECEIVED = "COMPANIES_RECEIVED";
export const CATEGORIES_RECEIVED = "CATEGORIES_RECEIVED";
export const CATALOGUE_URL = "/catalog";
export const CATALOGUE_ERROR = "CATALOGUE_ERROR";
export const SEARCH_RESULTS_RECEIVED = "SEARCH_RESULTS_RECEIVED";
export const PASSWORD_SUCCESS = "PASSWORD_SUCCESS";
export const UPDATE_MFA_STATUS = "UPDATE_MFA_STATUS";
export const SELECTED_BOT_ID = "SELECTED_BOT_ID";


export function fetchBots(query, noSpinner) {
	return (dispatch, getState) => {
		const selectedDomain = getState().domain.selectedDomain;
		if (!selectedDomain) return;

		UserServiceClientApi.getCatalog({
			isWebRequest: true,
			query: JSON.stringify(query),
			selectedDomain: selectedDomain,
		}, noSpinner)
			.then((data) => {
				const bots = data.data?.bots || [];
				dispatch({
					type: BOTS_RECEIVED,
					data: { bots: bots.filter((bot) => !bot.systemBot) },
				});
			})
			.catch((error) => {
				if (error.message === "User is offline") {
					console.warn("Offline: Cannot fetch bots.");
				} else {
					console.error("Error fetching bots:", error);
				}
			})
			.finally(() => {
				dispatch(setLoader(false));
			});
	};
}

export function passwordAuthSuccess() {
	return (dispatch) => {
		dispatch({
			type: PASSWORD_SUCCESS,
			data: { mfaStatus: "validateNumber" },
		});
	};
}

export function updateMFAStatus(data) {
	return (dispatch) => {
		dispatch({
			type: UPDATE_MFA_STATUS,
			data: { mfaStatus: data },
		});
	};
}
export function selectedBotId(data) {
	return (dispatch) => {
		// AudioElement.pauseRing();
		dispatch({
			type: SELECTED_BOT_ID,
			data: {
				selectedBotId: data.botId,
				conversationBot: data.conversationBot,
			},
		});
	};
}

export function fetchCompanies() {
	return (dispatch, getState) => {
		const selectedDomain = getState().domain.selectedDomain;
		if (!selectedDomain) return;

		UserServiceClientApi.getCatalog({
			isWebRequest: true,
			output: "companies",
			selectedDomain: selectedDomain,
		}).then(function (data) {
			let companies = data.companies;
			let cKeys = Object.keys(companies);
			let results = {};
			cKeys.map((key) => {
				results[key] = companies[key].bots;
			});
			if (!getState().user.isLicenseValid) {
				// dispatch(isCorporateLicenseValid(true));
			}
			dispatch({
				type: COMPANIES_RECEIVED,
				data: { companies: results },
			});
		});
	};
}

export function fetchCategories() {
	return (dispatch, getState) => {
		const selectedDomain = getState().domain.selectedDomain;
		if (!selectedDomain) return;

		UserServiceClientApi.getCatalog({
			isWebRequest: true,
			output: "categories",
			selectedDomain: selectedDomain,
		})
		.then((data) => {
			const categories = data.data?.categories || {};
			const cKeys = Object.keys(categories);
			const results = {};

			cKeys.forEach((key) => {
				results[key] = categories[key].bots.filter((bot) => !bot.systemBot);
			});

			dispatch({
				type: CATEGORIES_RECEIVED,
				data: { categories: results },
			});
		})
		.catch((error) => {
			if (error.message === "User is offline") {
				console.warn("Offline: Cannot fetch categories.");
			} else {
				console.error("Error fetching categories:", error);
			}
		})
		.finally(() => {
			dispatch(setLoader(false));
		});
	};
};


export function subscribeToBot(botId, type) {
	return (dispatch, getState) => {
		const selectedDomain = getState().domain.selectedDomain;
		if (!selectedDomain) return;

		UserServiceClientApi.subscribeBot({ botId })
			.then(() => {
				dispatch(fetchBotSubscriptions({ userDomain: selectedDomain }, botId, true, true, type));
			})
			.catch((error) => {
				if (error.message === "User is offline") {
					console.warn("You're offline. Cannot subscribe to the bot.");
				} else {
					console.error("Error subscribing to the bot:", error);
				}
				dispatch({ type: CATALOGUE_ERROR });
			});
	};
};


export function searchCatalogue(searchKey) {
	if (!searchKey || searchKey.length === 0) {
		return {
			type: SEARCH_RESULTS_RECEIVED,
			data: { bots: [], searchKey },
		};
	}

	return (dispatch, getState) => {
		const selectedDomain = getState().domain.selectedDomain;
		if (!selectedDomain) return;

		UserServiceClientApi.getCatalog({
			isWebRequest: true,
			query: JSON.stringify({ searchKey }),
			selectedDomain,
		})
		.then((data) => {
			const bots = data?.data?.bots ?? []
			const botArray = [...bots];
			dispatch({
				type: SEARCH_RESULTS_RECEIVED,
				data: {
					searchResults: botArray.filter((bot) => bot),
					searchKey,
				},
			});
		})
		.catch((error) => {
			if (error.message === "User is offline") {
				console.warn("You're offline. Search cannot be performed.");
			} else {
				console.error("Error searching catalogue:", error);
			}
		})
		.finally(() => {
			dispatch(setSearchLoader(false));
		});
	};
};

// onUnsubscribe = e => {
//   e.preventDefault();
//   e.stopPropagation();
//   const botId = e.currentTarget.dataset.botid;
//   const data = { botId };
//   let url = `/bots/unsubscribe`;
//   Ajax.post(url, data)
//     .then(this.props.getBotSubscriptions)
//     .catch(error => {
//       Notify({
//         type: "error",
//         message: "An unexpected error occurred.Cannot Unsubscribe Bots"
//       });
//     });
// };
